export const trainingAssignmentObjectName = 'training_assignment__a';
export const courseObjectName = 'course__a';
